import { get } from 'lodash';
import { getSortCodeAndAccountNumber, formatDisplayName, getDisplayOrder } from './helpers';

const byDisplayOrder = (account1, account2) => account1.display_order - account2.display_order;

export const formatAccount = (account, index) => {
	const { bacs = [], id, type, number, bank_id, metadata, actions_available, balances, currency, product } = account;
	const { sortCode, accountNumber } = getSortCodeAndAccountNumber(number);
	return {
		id,
		type,
		sortCode,
		accountNumber,
		number,
		bank_id,
		displayName: formatDisplayName(account),
		accountName: get(metadata, 'account_name'),
		display_order: getDisplayOrder({ index, account }),
		metadata,
		actionsAvailable: actions_available,
		balances,
		currency,
		product,
		bacs,
	};
};

export const formatAccounts = (accounts) => accounts.map(formatAccount).sort(byDisplayOrder);
